<template>
  <header 
    class="page-header"
    :class="current.toLowerCase()"
    v-if="!(current === 'Add' || current === 'View' || current === 'Modify' || current === 'ViewStat')"
  >
    <h2 class="tit-h2">
      {{ menuList[current]?.title }}
    </h2>
    <div 
      class="btn-group"
    >
      <template v-if="current === 'Board' || current === 'Manage'">
        <router-link :to="{name: 'Add'}">
          <el-button 
            type="primary"
            size="large"
          >
            {{ menuList['Add'].label }}
          </el-button>
        </router-link>
      </template>
      <template v-if="'Board' !== current && current === 'Manage'">
        <router-link :to="{name: 'Board'}">
          <el-button 
            type="primary"
            size="large"
          >
          <font-awesome-icon
            :icon="menuList['Board'].icon" 
          />
            {{ menuList['Board'].label }}
          </el-button>
        </router-link>
      </template>
      <template v-if="'Manage' !== current">
        <router-link :to="{name: 'Manage'}">
          <el-button 
            type="primary"
            size="large"
          >
            {{ menuList['Manage'].label }}
          </el-button>
        </router-link>
      </template>
      <template v-if="'PlanList' !== current">
        <router-link :to="{name: 'PlanList'}">
          <el-button 
            type="primary"
            size="large"
          >
            <font-awesome-icon
              :icon="menuList['PlanList'].icon" 
            />
            {{ menuList['PlanList'].label }}
          </el-button>
        </router-link>
      </template>
      <template v-if="'PaymentList' !== current">
        <router-link :to="{name: 'PaymentList'}">
          <el-button 
            type="primary"
            size="large"
          >
            <font-awesome-icon
              :icon="menuList['PaymentList'].icon" 
            />
            {{ menuList['PaymentList'].label }}
          </el-button>
        </router-link>
      </template>
    </div>
  </header>
  <router-view />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const current = ref(route.name)

watch(route, () => {
  current.value = route.name
})

const menuList = {
  Add: { title: '리퀘스트 추가', label: '리퀘스트 추가' },
  Board: { title: '수동 유료 고객 관리 보드', label: '대쉬보드', icon: 'fa-solid fa-table-columns' },
  Manage: { title: '리퀘스트 관리', label: '리퀘스트 관리' },
  PlanList: { title: '플랜 리스트', label: '플랜', icon: 'fa-solid fa-table-list' },
  PaymentList: { title: '결제 리스트', label: '결제', icon: 'fa-solid fa-table-list' },
}


</script>